import React from 'react';

import { URL_SISTEMA_NOVO } from 'utils/bloqueioNovasOS';
import { Container } from './bloqueadoStyles';

const NovasOSBloqueadas: React.FC = () => (
  <Container>
    <h1>A abertura de novas OS mudou de lugar</h1>

    <p>
      Desde 01/09/2026 as novas OS passaram a ser abertas no sistema novo. Este
      sistema continua no ar normalmente para consultar e alterar as OS já
      existentes.
    </p>

    <a href={URL_SISTEMA_NOVO} target="_blank" rel="noopener noreferrer">
      Abrir OS no sistema novo
    </a>
  </Container>
);

export default NovasOSBloqueadas;
